export type JobScheduleDetailPageTabType = "summary" | "logs";

export const jobScheduleDetailPageTabsValues: {
  [key in JobScheduleDetailPageTabType]: JobScheduleDetailPageTabType;
} = {
  summary: "summary",
  logs: "logs",
};
